import { render } from "./QuestionsUpdatedSup.vue?vue&type=template&id=707cfedc&scoped=true"
import script from "./QuestionsUpdatedSup.vue?vue&type=script&lang=js"
export * from "./QuestionsUpdatedSup.vue?vue&type=script&lang=js"

import "./QuestionsUpdatedSup.vue?vue&type=style&index=0&id=707cfedc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707cfedc"]])

export default __exports__